import { Link } from 'react-router-dom'
import rentCategoryImage from '../assets/jpg/rentCategoryImage.jpg'
import sellCategoryImage from '../assets/jpg/sellCategoryImage.jpg'
import burjkhalifadubai from '../assets/jpg/burjkhalifadubai.jpg'

function Explore() {
  return (
    <div className="explore">
      <header className="discoverheader">
        <p className="pageHeader" id="discover">
          Discover your perfect property with us.
        </p>
        <p className="exploreCategoryHeading">
          Building trust with our partners since 2005
        </p>
      </header>

      <main>
        {/* <Slider /> */}

        <div className="exploreCategories">
          <Link to="/category/rent">
            <img
              src={rentCategoryImage}
              alt="rent"
              className="exploreCategoryImg"
            />
            <p className="exploreCategoryName">Places for rent</p>
          </Link>
          <Link to="/category/sale">
            <img
              src={burjkhalifadubai}
              alt="sell"
              className="exploreCategoryImg"
            />
            <p className="exploreCategoryName">Places for sale</p>
          </Link>
        </div>
        {/* <div className="flexx">
          <img className="brand" src={dubai} alt="" />
          <div className="aboutCompany">
            <h4>Homescare Real Estate Broker L.L.C.</h4>
            <p>
              The company works in real estate and conducts management,
              operation, development, marketing and maintenance services for all
              types of real estate, residential, commercial, administrative, as
              well as real estate consultancy for all types of properties to
              maximize value and increase revenue as it is undertaking a number
              of other services (Cleaning services - Buffets - Expansion in the
              application of security systems for all properties).
            </p>
          </div>
        </div> */}
      </main>
    </div>
  )
}

export default Explore
